// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { PRECIO_JUSTO_ACT_CLEAN_DICTIONARY_STATES } from './constants'

export function actCleanDictionaryStates() {
  return {
    type: PRECIO_JUSTO_ACT_CLEAN_DICTIONARY_STATES,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRECIO_JUSTO_ACT_CLEAN_DICTIONARY_STATES:
      return {
        ...state,
        normalizedAndTerms: '',
        dictionaryRowData: null,
      }

    default:
      return state
  }
}
